export default __webpack_public_path__ + "static/media/stock1.38f3c853.png";